import { useState, useEffect, useCallback } from 'react';
import { router } from '@inertiajs/react';
import { useSurveyDismissed } from './useSurveyDismissed';

const NAV_THRESHOLD = 5;

export const useCsatSurvey = () => {
  const [dismissed, setDismissed] = useSurveyDismissed();
  const [navCount, setNavCount] = useState(0);
  const [isOnRates, setIsOnRates] = useState(false);

  useEffect(() => {
    const removeListener = router.on('navigate', (event) => {
      const url = event.detail.page.url;
      const onRates = url.includes('/rates');
      setIsOnRates(onRates);

      if (!onRates) {
        setNavCount((prev) => prev + 1);
      }
    });
    return () => removeListener();
  }, []);

  const show = !dismissed && !isOnRates && navCount >= NAV_THRESHOLD;

  const dismiss = useCallback(() => {
    setDismissed(true);
  }, [setDismissed]);

  return { show, dismiss };
};
